<template>
  <div
    id="themeSwitcher"
    class="cursor-pointer text-xl px-1 rounded-full border border-gray-300 w-12 bg-sky-200 dark:bg-sky-700"
  >
    <div class="block dark:hidden">
      <i class="fa-solid fa-moon"></i>
    </div>
    <div class="hidden dark:block text-amber-100 text-right">
      <i class="fa-solid fa-lightbulb"></i>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { onMounted } from 'vue'

  onMounted(() => {
    const waitForElement = (selector, callback) => {
      const el = document.querySelector(selector)
      if (el) return callback(el)
      requestAnimationFrame(() => waitForElement(selector, callback))
    }

    waitForElement('#themeSwitcher', (themeSwitcher) => {
      const userTheme = localStorage.getItem('theme')
      const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches

      const themeCheck = () => {
        if (userTheme === 'dark' || (!userTheme && systemTheme)) {
          document.documentElement.classList.add('dark')
        } else {
          document.documentElement.classList.remove('dark')
        }
      }

      const themeSwitch = () => {
        if (document.documentElement.classList.contains('dark')) {
          document.documentElement.classList.remove('dark')
          localStorage.setItem('theme', 'light')
          console.log('💡Changed to light theme')
        } else {
          document.documentElement.classList.add('dark')
          localStorage.setItem('theme', 'dark')
          console.log('🌙Changed to dark theme')
        }
      }

      themeCheck()
      themeSwitcher.addEventListener('click', themeSwitch)
    })
  })
</script>
